// Rule below disabled to avoid cyclic dependencies causing uninitialized imports
// eslint-disable-next-line monorepo/no-internal-import
import {useValueAfterHydration} from '@aboutyou/ui-components/src/hooks/useValueAfterHydration/useValueAfterHydration';

declare const window: Window &
  typeof globalThis & {
    MSStream: {};
  };

export type PhoneOS = 'android' | 'ios' | 'macOS' | 'windows' | 'unknown';

export function useUserAgent() {
  return useValueAfterHydration(
    () => window.navigator.userAgent || window.navigator.vendor || window.opera,
  );
}

export function useOS(): PhoneOS {
  const UA = useUserAgent();

  if (UA === undefined) {
    return 'unknown';
  }

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(UA)) {
    return 'windows';
  }

  if (/android/i.test(UA)) {
    return 'android';
  }

  if (/iP(ad|hone|od)/.test(UA) && !window.MSStream) {
    return 'ios';
  }

  return 'unknown';
}

export const useIsMacOsSafari = () => {
  return useValueAfterHydration(
    () =>
      /Safari/.test(window.navigator.userAgent) &&
      !/Chrome/.test(window.navigator.userAgent),
  );
};

export const useIsSafariOrFirefox = () => {
  return useValueAfterHydration(
    () =>
      (/Safari/.test(window.navigator.userAgent) ||
        /Firefox/.test(window.navigator.userAgent)) &&
      !/Chrome/.test(window.navigator.userAgent),
  );
};
